import { render, staticRenderFns } from "./modalAddSquad.vue?vue&type=template&id=6ec894fc&"
import script from "./modalAddSquad.vue?vue&type=script&lang=js&"
export * from "./modalAddSquad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports